<template lang="pug">
  div(class="billing-act-viewer")
    div(class="billing-act-viewer__viewer")
      m-pdf-viewer(
        :src="src"
        type="documents"
      )
    div(class="billing-act-viewer__actions")
      v-btn(
        class="main-button w-50"
        @click="signAct(act)"
      ) {{ $t('Sign') }}
      v-menu(
        offset-y
        top
        left
      )
        template(v-slot:activator="{ on }")
          v-btn(
            v-on="on"
            class="square-icon-button square-icon-button--lg"
          )
            e-svg-icon arrow-download
        m-list-actions(:actions="downloadMenuItems")
</template>

<script>
import Base64js from 'base64-js'
import Download from 'js-file-download'
import MPdfViewer from '~/components/modules/m-pdf-viewer'
import edsIitCheckboxDialog from '~/modules/eds-iit-checkbox/mixins/edsIitCheckboxDialog'
import MListActions from '~/components/modules/lists/m-list-actions'

export default {
  name: 'BillingActViewer',
  components: {
    MPdfViewer,
    MListActions
  },
  mixins: [edsIitCheckboxDialog],
  props: {
    act: {
      type: Object,
      required: true
    },
    src: {
      type: String,
      required: true
    }
  },
  computed: {
    downloadMenuItems() {
      return [
        {
          text: this.$t('Download protocol'),
          icon: 'printer-3',
          call: () => this.downloadAct(this.act, 'protocol')
        },
        {
          text: this.$t('Download signed act'),
          icon: 'key-4',
          call: () => this.downloadAct(this.act, 'signed')
        }
      ]
    }
  },
  methods: {
    async downloadAct(act, type = 'signed') {
      try {
        const blob = await this.$store.dispatch('acts/downloadAct', { id: act?.id, type })
        if (blob) {
          Download(blob, `act-${act.number}.pdf`)
        }
        return blob
      } catch (e) {
        this.$handlers.error(e, this)
      }
    },
    async signAct(act) {
      return await this.useEdsIitCheckboxDialog({
        type: 'edsIitCheckboxCommon',
        method: 'open',
        keyCheck: false,
        pluginTitles: {
          options: this.$t('signPlugin.signAct')
        },
        onConfirm: async ({ dialogClosed, edsKeyData, isDiia, isMono, sign, isStamp }) => {
          if (dialogClosed) {
            return
          } else if (!edsKeyData?.keyData && !isDiia && !isMono) {
            this.$handlers.error(
              'We could not read the key data. Please try again or choose a different key',
              this
            )
            return
          }
          try {
            const filesToSign = []
            const file = Base64js.toByteArray(this._.get(act, 'fileHash', ''))
            let signedFile
            if (isDiia || isMono) {
              filesToSign.push({
                name: this._.get(act, 'number'),
                content: file,
                isHashed: true,
                externalId: this._.get(act, 'id')
              })
              signedFile = await sign(filesToSign, { keyCheck: false })
              if (!signedFile || !signedFile.length) {
                return
              }
            } else {
              signedFile = await sign(file, {
                keyCheck: false,
                title: 'Підпис акту: ' + this._.get(act, 'number')
              })
              if (!signedFile) {
                return
              }
            }
            const payload = {
              signature: isDiia || isMono ? this._.get(signedFile[0], 'signature') : signedFile
            }
            await this.$store.dispatch('acts/signAct', { id: act?.id, payload })
            this.$notification.success(this.$t('Act has been signed successfully'))
          } catch (e) {
            this.$handlers.error(e, this)
            return false
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.billing-act-viewer {
  position: relative;

  &__viewer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 40px 40px 0 40px;
  }
  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $white;
    padding: 16px;
    border-top: 1px solid $border-disabled;
    border-radius: 0 0 16px 16px;
  }
}
</style>
